var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "520px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.onOpen
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "110px", size: "small" } },
        [
          !_vm.isEditItem
            ? _c(
                "el-form-item",
                { attrs: { label: "岗位", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: !!_vm.headerRow,
                        placeholder: "请选择岗位"
                      },
                      model: {
                        value: _vm.form.stationName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "stationName", $$v)
                        },
                        expression: "form.stationName"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(s) {
                      return _c("el-option", {
                        key: s.value,
                        attrs: { label: s.label, value: s.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.isEditItem
            ? _c(
                "el-form-item",
                { attrs: { label: "人员", required: "" } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      filterable: "",
                      clearable: "",
                      disabled: !!_vm.headerRow,
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      "default-value": _vm.form.userId,
                      "callback-params": { key: "userId" }
                    },
                    on: { parentCallBack: _vm.onUserSelected }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.headerRow
            ? _c("el-form-item", { attrs: { label: "人员" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.headerRow.userName || _vm.headerRow.userId))
                ])
              ])
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "成本类型", required: "" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.costType,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "costType", $$v)
                    },
                    expression: "form.costType"
                  }
                },
                _vm._l(_vm.costTypeOptions, function(t) {
                  return _c("el-option", {
                    key: t.value,
                    attrs: { label: t.label, value: t.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "金额", required: "" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: { min: 0, precision: 2, step: 100 },
                model: {
                  value: _vm.form.amount,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "amount", $$v)
                  },
                  expression: "form.amount"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 2,
                  maxlength: "500",
                  "show-word-limit": ""
                },
                model: {
                  value: _vm.form.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "按月自动累加" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.autoMonthlyChecked,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "autoMonthlyChecked", $$v)
                    },
                    expression: "form.autoMonthlyChecked"
                  }
                },
                [_vm._v("每月1日自动累加一条相同成本")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }